import { mapActions, mapGetters } from 'vuex'
import util from '@/util'

export default {
  name: 'UpgradePlano',
  props: {
    plano: {
      type: Object,
      required: true,
      default: () => ({})
    }
  },
  data: () => {
    return {
    }
  },
  computed: {

    ...mapGetters('carrinho', ['temProdutoMirtContratado'])
  },
  async mounted () {
    this.$router.push({ name: 'recursos' })
  },
  methods: {
    ...mapActions('carrinho', ['ActionAdicionarItemCarrinho', 'ActionLimparDadosCarrinho']),
    enviarParaCarrinho (plano) {
      if (this.temProdutoMirtContratado) {
        this.$router.push({ name: 'carrinho' }).then(() => {
          util.criarAlertaToastDeSucesso(this, 'Aviso', 'Este produto já está no carrinho')
        })
        return
      }
      this.ActionLimparDadosCarrinho()

      const item = {
        produto: {
          nome: plano.produto.nome,
          id: plano.produto.id,
          icone: plano.produto.icone,
          quantidade: 1,
          plano: {
            id: plano.id,
            valor: plano.valor,
            descricao: plano.descricao,
            item_planos: plano.item_planos
          }
        }
      }
      this.ActionAdicionarItemCarrinho(item)
      this.$router.push({ name: 'carrinho' })
    },
    compararPlanos () {
      this.$router.push({ name: 'alterar-plano-contrato' })
    }
  }
}
